import styled from "styled-components/macro";

export const CheckBoxContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 460px;
  flex-direction: row;
`;

export const CheckBoxFinePrintLabel = styled.label`
  font-size: 13px;
  line-height: ${({ theme }) => theme.resolve("line_height_md")};
  letter-spacing: 0;
  color: ${({ theme }) => theme.primaryTextColor};
  cursor: pointer;
`;

export const GrayBox = styled.section`
  background-color: ${({ theme }) => theme.secondaryBG};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.primaryBorder};
  width: 100%;
`;

export const SectionTitle = styled.h3`
  font-size: 19px;
  font-weight: 600;
  margin-top: 50px;
`;

/** A bold sub-heading used above a form section, e.g. "Address" or "Point of Contact" in a slideout. */
export const FormSectionHeading = styled.h4`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_semibold")};
  font-size: ${({ theme }) => theme.resolve("font_size_base")};
  line-height: ${({ theme }) => theme.resolve("line_height_xl")};
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  margin: 0;
`;

/** A bordered card used to group related fields within a form section, e.g. Point of Contact fields. */
export const FormSectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_lg")};
  width: 100%;
  padding: ${({ theme }) => theme.resolve("spacing_lg")};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
`;

/** A full-width, equal-split Cancel/Save button row used in the footer of slideout forms. */
export const FullWidthButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  padding-top: ${({ theme }) => theme.resolve("spacing_md")};

  button {
    flex: 1;
  }
`;

export const StatusBox = styled.div`
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  border: solid 0.6px ${({ theme }) => theme.primaryBorder};
  background-color: ${({ theme }) => theme.secondaryBG};
  color: 0f1d2b;
  font-size: 13px;
  padding: 10px 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  p {
    padding: 5px 0;
    margin: 0 auto;
    color: ${({ theme }) => theme.secondaryButtonTextColor};
  }
`;

export const StatusBoxLine = styled.div`
  height: 20px;
  width: 100%;
  position: relative;
  &::after {
    content: "";
    height: 100%;
    border-left: ${({ theme }) => theme.resolve("border_md")} solid
      ${({ theme }) => theme.primaryBorder};
    width: 1px;
    position: absolute;
    left: 50%;
    top: 0;
  }
`;

export const SmallTextField = styled.div`
  max-width: 176px;
`;
interface ICustomTermInput {
  highlight: boolean;
  has_error: boolean;
}

export const CustomTermContainer = styled.div<ICustomTermInput>`
  .select__control {
    border: ${({ theme }) => theme.resolve("border_md")} solid
      ${({ has_error, highlight, theme }) =>
        has_error
          ? "inherit"
          : highlight
          ? theme.warningTextColor
          : theme.primaryBorder};

    box-shadow: ${({ has_error, highlight, theme }) =>
      has_error
        ? "inherit"
        : highlight
        ? `0px 0px 3px 0px ${theme.warningTextColor}`
        : "none"};
  }
`;

export const WarningMessage = styled.span`
  color: ${({ theme }) => theme.warningTextColor};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`;

export const WarningMessageBox = styled.span`
  color: ${({ theme }) => theme.warningTextColor};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  padding: 5px;
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.warningTextColor};
  background-color: ${({ theme }) => `${theme.warningTextColor}20`};
  border-radius: 3px;
  margin: 10px 0;
  display: flex;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  align-items: center;
`;

export const InfoMessageBox = styled.div`
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.brandColor};
  background-color: ${({ theme }) => `${theme.brandColor}10`};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
`;

export const SuccessMessageBox = styled.div`
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.successIconColor};
  background-color: ${({ theme }) => `${theme.successIconColor}10`};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
`;

export const ErrorMessageBox = styled.div`
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.errorColor};
  background-color: ${({ theme }) => `${theme.errorColor}10`};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
`;
